import * as firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/auth';
import {getAnalytics} from 'firebase/analytics';
import {GoogleAuthProvider, getAuth, signInWithPopup, signOut} from 'firebase/auth';

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  measurementId: process.env.REACT_APP_FIREBASE_MEASURE_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
});

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const analytics = getAnalytics(app);


export const logout = (afterAction = () => {
}) => {
  signOut(auth).then(r => afterAction(null));
};

export const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    window.location.reload();
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
